import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Icons from "../assets/icons";
import { useLocation } from "react-router-dom";
import scrollToRef from "../utils/scrollTarget";

const ContactData = [
  {
    location: "introLocation_1",
    address: "introAddress_1",
    map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.9918316352764!2d127.11946237637802!3d37.48451912882609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9f654a27e05f%3A0x1c94e486c2c154f2!2z7JeQ7Iqk7JSo7KeA7IaU66Oo7IWY7KaIKOyjvCk!5e0!3m2!1sko!2skr!4v1684820097086!5m2!1sko!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    call: "02 - 827 - 0020",
    fax: "02 - 828 - 5377",
  },
  {
    location: "introLocation_2",
    address: "introAddress_2",
    map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.5247970773116!2d126.96941307638022!3d37.54269772549399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2068f8f09df%3A0xd93536ffb2b4e29a!2z7JeQ7Iqk7JSo7KeA7IaU66Oo7IWY7KaIKOyjvCkg7Jqp7IKw7KeA7KCQ!5e0!3m2!1sko!2skr!4v1685500430387!5m2!1sko!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    call: "1811 - 7247",
  },
  {
    location: "introLocation_4",
    address: "introAddress_4",
    map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.387397507254!2d129.12573307630086!3d35.171895857784214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356893bd1b0840f3%3A0x47058929279573d5!2z7JeQ7Iqk7JSo7KeA7IaU66Oo7IWY7KaIKOyjvCkg67aA7IKw7KeA7IKs!5e0!3m2!1sko!2skr!4v1685500356217!5m2!1sko!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    call: "010 - 2830 - 4242",
  },
  {
    location: "introLocation_5",
    address: "introAddress_5",
    map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3213.05439984229!2d127.37630667633995!3d36.35946119241917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35654b6f5364c983%3A0x322c51ff1ab6e6df!2z7JeQ7Iqk7JSo7KeA7IaU66Oo7IWY7KaIKOyjvCkg64yA7KCE7KeA7IKs!5e0!3m2!1sko!2skr!4v1685500377371!5m2!1sko!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
  },
  {
    location: "introLocation_6",
    address: "introAddress_6",
    map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.9055382306706!2d126.95177678906866!3d37.53372395394575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3cb1d2030f5%3A0xa663af77e99d4240!2z7JeQ7Iqk7JSo7KeA7IaU66Oo7IWY7KaIKOyjvCkg7Jqp7IKwIOusvOulmOyEvO2EsA!5e0!3m2!1sko!2skr!4v1685500398803!5m2!1sko!2skr" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
  },
];

const IntroStyle = styled.ul`
  .scroll {
    min-height: calc(var(--vh, 1vh) * 100 - 50px);
    overflow: hidden;
    position: relative;
  }
`;

const ContactMainStyle = styled.div`
  .scroll {
    min-height: 600px;
  }
  .banner-image {
    background: url("/background/contact-bg1.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    .banner-text {
      margin: auto;
      background: #ffffff99;
      color: #000;
      width: 100%;
      padding: 50px 0;
      text-align: center;
      h1 {
        font-size: 60px;
        line-height: 1em;
        margin: auto;
      }
    }
  }
  @media (max-width: 768px) {
    .scroll {
      min-height: 400px;
    }
    .banner-image {
      .banner-text {
        h1 {
          font-size: 30px;
        }
      }
    }
  }
`;
const ContactMain = ({ t, i18n }: any) => {
  return (
    <ContactMainStyle>
      <div className="banner-image scroll">
        <motion.div
          initial={{ transform: "scaleX(0)", opacity: 0 }}
          animate={{ transform: "scaleX(1)", opacity: 1 }}
          transition={{ ease: "easeOut", duration: 0.7 }}
          className="banner-text"
        >
          <motion.h1
            initial={{ translateY: "-50px", opacity: 0 }}
            animate={{ translateY: "0", opacity: 1 }}
            transition={{ delay: 0.3, ease: "easeInOut", duration: 1 }}
          >
            {t("introContact")}
          </motion.h1>
        </motion.div>
      </div>
    </ContactMainStyle>
  );
};

const ContactStyle = styled.div`
  .scroll {
    display: flex;
    min-height: unset;
    max-width: 1200px;
    width: 95%;
    margin: 50px auto;
  }
  .contact-frame {
    margin: auto;
    width: 100%;
    .contact-select {
      line-height: 1.2em;
      word-break: keep-all;
      display: flex;
      border-bottom: 2px solid #6a6e77;
      color: #6a6e77;
      li {
        width: 100%;
        display: flex;
        height: 60px;
        p {
          margin: auto;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
    .contact-box {
      overflow: auto;
      margin: 20px auto;
      display: flex;
      flex-direction: column;
      .contact-location {
        display: flex;
        margin-right: 5px;
        svg {
          max-height: 20px;
          width: 20px;
          margin: auto;
          path {
            fill: #6a6e77;
          }
        }
      }
      div {
        margin-top: 10px;
      }
      p {
        display: flex;
        font-size: 16px;
        padding: 5px 0;
      }
    }
  }
  h1 {
    text-align: center;
    padding: 30px 0;
    font-size: 40px;
  }
  .button {
    min-width: 120px;
    text-align: center;
    padding: 5px 15px;
    background: #fff;
    transition: 0.3s;
    &.active {
      color: #fff;
      background: #6a6e77;
    }
  }
  @media (max-width: 768px) {
    .contact-frame {
      .contact-select {
        flex-wrap: wrap;
        li {
          width: calc(100% / 3);
          height: 36px;
          p {
            font-size: 16px;
          }
        }
      }
      .contact-box {
        margin: 10px auto;
        p {
          font-size: 14px;
          .contact-location {
            width: 20px;
            svg {
              margin-top: 3px;
            }
          }
        }
      }
    }
    h1 {
      padding: unset;
      padding-bottom: 20px;
      font-size: 25px;
    }
    .button {
      min-width: unset;
      padding: unset;
    }
  }
`;
const Contact = ({ t, i18n }: any) => {
  const [contact, setContact] = useState(t("introLocation_1"));
  useEffect(() => {
    setContact(t("introLocation_1"));
  }, [i18n.language]);

  const contactData = ContactData.filter(
    (data) => t(data.location) === t(contact) && data
  );
  return (
    <ContactStyle>
      <div className="scroll">
        <div className="contact-frame" id="contact-frame">
          {/* <h1>{t("introContact")}</h1> */}
          <ul className="contact-select">
            {ContactData.map((res, idx) => {
              return (
                <li
                  key={idx}
                  onClick={() => setContact(t(res.location))}
                  className={`button pointer ${
                    t(res.location) === contact ? "active" : ""
                  }`}
                >
                  <p className="contact-contents" key={idx}>
                    {t(res.location)}
                  </p>
                </li>
              );
            })}
          </ul>
          {contactData.map((res, idx) => {
            return (
              <ul key={idx} className="contact-box">
                <p>
                  <span className="contact-location">
                    <Icons.IconLocation></Icons.IconLocation>
                  </span>
                  <span>{t(res.address)}</span>
                </p>
                <div dangerouslySetInnerHTML={{ __html: res.map }}></div>
              </ul>
            );
          })}
        </div>
      </div>
    </ContactStyle>
  );
};

const IntroContact = ({ t, i18n }: any) => {
  const location = useLocation();
  const up1 = useRef(null);
  const options = {
    root: null,
    rootMargin: "-10%",
    threshold: 0,
  };
  useEffect(() => {
    switch (location.state) {
      case 0:
        scrollToRef(up1, location);
        break;
      default:
        break;
    }
  }, [location.state]);

  useEffect(() => {
    const observer = new IntersectionObserver((e) => {
      e.map((f) => {
        return f.isIntersecting && f.target.classList.add("up");
      });
    }, options);
    up1.current && observer.observe(up1.current);
  });
  return (
    <IntroStyle className="no-select">
      <ContactMain t={t} i18n={i18n} />
      <section className="up-soon" ref={up1}>
        <Contact t={t} i18n={i18n} />
      </section>
    </IntroStyle>
  );
};

export default IntroContact;
